<template>
  <div>
    <el-button @click="goBack" class="navbar-back-navigation-item">
      <span class="plus-icon"
        ><img src="@/assets/images/icons/arrow-left.svg" alt="" /></span
      >Back
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emrOrderRouteNames: [
        "View-Case-Information",
        "Finalized-Reports",
        "View-Configuration",
        "ViewEmrOrders",
      ],
      hospitalRouteNames: [
        "HospitalDetails",
        "Hospital-Primary-Information",
        "Branches-List",
        "HospitalPhysicians",
        "HospitalAccountManagers",
        "HospitalAdmins",
      ],
      resultFilesViewProgressRouteNames: [
        "viewprogress",
        "ToStartResultFilesViewProgress",
        "ProcessingResultFilesViewProgress",
        "FailedResultFilesViewProgress",
        "CompletedResultFiles",
      ],
      qcChartRouteNames: ["QCChartFileUpload"],
      labTestPanelRoute: ["LabUsers", "TestPanel"],
      bulkAccessionViewRouteName: [
        "BulkAccessionsInfo",
        "PendingBulkAccessionView",
        "FailedBulkAccessionView",
        "CompleteBulkAccessionView",
      ],
    };
  },
  methods: {
    goBack() {
      try {
        if (this.$route.query && this.$route.query.redirectRoute) {
          let query = this.$route.query;
          let redirectRoute = this.$route.query.redirectRoute;
          delete query.redirectRoute;
          let params = {};

          if (query.case_id) {
            params.case_id = query.case_id;
            delete query.case_id; // remove from query
          }
          this.$router.push({
            name: redirectRoute,
            params: params,
            query: query,
          });
        } else if (
          this.$route.query &&
          this.$route.query.redirectRoute &&
          this.$route.query.params
        ) {
          let query = this.$route.query;
          let params = this.$route.query.params;
          let redirectRoute = this.$route.query.redirectRoute;
          delete query.redirectRoute;
          this.$router.push({
            name: redirectRoute,
            query: query,
            params: params,
          });
        } else if (
          (this.$route.query && this.$route.query.selectedPageSize) ||
          this.$route.query.selectedPage ||
          this.$route.query.selected_panel
        ) {
          this.$router.push({
            path: "/all-cases",
            query: {
              selectedCase: this.$route.query.selectedCase,
              selectedPage: this.$route.query.selectedPage,
              selectedHospital: this.$route.query.selectedHospital,
              selectedPhysician: this.$route.query.selectedPhysician,
              selectedStatus: this.$route.query.selectedStatus,
              selectedPageSize: this.$route.query.selectedPageSize,
              selectedString: this.$route.query.selectedString,
              selectedSearchBy: this.$route.query.selectedSearchBy,
              selectedDateOfBirth: this.$route.query.selectedDateOfBirth,
              selectedCaseOrderBy: this.$route.query.selectedCaseOrderBy,
              selectedCaseOrderType: this.$route.query.selectedCaseOrderType,
              selectedEMR: this.$route.query.selectedEMR,
              selectedAccessionId: this.$route.query.selectedAccessionId,
              selectedUser: this.$route.query.selectedUser,
              selectedMarketer: this.$route.query.selectedMarketer,
              selectedTest: this.$route.query.selectedTest,
              selectedPatientName: this.$route.query.selectedPatientName,
              selectedException: this.$route.query.selectedException,
            },
          });
        } else if (this.emrOrderRouteNames.indexOf(this.$route.name) != -1) {
          this.$router.push({
            path: "/all-emr-orders",
            query: {
              selectedEmrPage: this.$route.query.selectedEmrPage,
              selectedEmrCaseType: this.$route.query.selectedEmrCaseType,
              selectedEmrHospital: this.$route.query.selectedEmrHospital,
              selectedEmrDateOfBirth: this.$route.query.selectedEmrDateOfBirth,
              selectedEmrPhysician: this.$route.query.selectedEmrPhysician,
              selectedEmrString: this.$route.query.selectedEmrString,
              selectedEmrPageSize: this.$route.query.selectedEmrPageSize,
              selectedEmrAccessionId: this.$route.query.selectedEmrAccessionId,
              selectedEmrSearchBy: this.$route.query.selectedEmrSearchBy,
              selectedEmrOrderBy: this.$route.query.selectedEmrOrderBy,
              selectedEmrOrderType: this.$route.query.selectedEmrOrderType,
              selectedStatus: this.$route.query.selectedStatus,
            },
          });
        } else if (this.hospitalRouteNames.indexOf(this.$route.name) != -1) {
          this.$router.push({
            path: "/ordering-facilities",
            query: {
              selectedOrderingFacilityPage:
                this.$route.query.selectedOrderingFacilityPage,
              selectedOrderingFacility:
                this.$route.query.selectedOrderingFacility,
              selectedOrderingFacilityFax:
                this.$route.query.selectedOrderingFacilityFax,
              selectedOrderingFacilityPhone:
                this.$route.query.selectedOrderingFacilityPhone,
              selectedOrderingFacilityString:
                this.$route.query.selectedOrderingFacilityString,
              selectedOrderingFacilityOrderBy:
                this.$route.query.selectedOrderingFacilityOrderBy,
              selectedOrderingFacilityOrderType:
                this.$route.query.selectedOrderingFacilityOrderType,
              selectedOrderingFacilityPageSize:
                this.$route.query.selectedOrderingFacilityPageSize,
              selectedOrderingFacilitySearchBy:
                this.$route.query.selectedOrderingFacilitySearchBy,
              selectedOrderingFacilityName:
                this.$route.query.selectedOrderingFacilityName,
                selectedOrderingFacilityFax:
                this.$route.query.selectedOrderingFacilityFax,
                selectedOrderingFacilityCode:
                this.$route.query.selectedOrderingFacilityCode,
                selectedOrderingFacilityPhone:
                this.$route.query.selectedOrderingFacilityPhone,
            },
          });
        } else if (
          this.resultFilesViewProgressRouteNames.indexOf(this.$route.name) != -1
        ) {
          this.$router.push({
            path: "/result-files",
            query: {
              selectedResultFilesPage:
                this.$route.query.selectedResultFilesPage,
              selectedResultFilesCase:
                this.$route.query.selectedResultFilesCase,
              selectedResultFilesOrderBy:
                this.$route.query.selectedResultFilesOrderBy,
              selectedResultFilesOrderType:
                this.$route.query.selectedResultFilesOrderType,
              selectedResultFilesPageSize:
                this.$route.query.selectedResultFilesPageSize,
              // selectedStatus: this.$route.query.selectedStatus,
            },
          });
        } else if (this.qcChartRouteNames.indexOf(this.$route.name) != -1) {
          this.$router.push({
            path: "/qc-chart/result-files",
            query: {
              selectedPage: this.$route.query.selectedPage,
              selectedPageSize: this.$route.query.selectedPageSize,
              selectedStatus: this.$route.query.selectedStatus,
            },
          });
        } else if (this.labTestPanelRoute.indexOf(this.$route.name) != -1) {
          this.$router.push({
            name: "AllLabs",
            query: {
              selectedLabPage: this.$route.query.selectedLabPage,
              selectedLabPageSize: this.$route.query.selectedLabPageSize,
              selectedLabString: this.$route.query.selectedLabString,
              selectedLabSearchBy: this.$route.query.selectedLabSearchBy,
              selectedOrderBy: this.$route.query.selectedOrderBy,
              selectedOrderType: this.$route.query.selectedOrderType,
            },
          });
        } else if (
          this.bulkAccessionViewRouteName.indexOf(this.$route.name) != -1
        ) {
          this.$router.push({
            path: "/bulk-accessions",
            query: {
              selectedBulkAccessionPage:
                this.$route.query.selectedBulkAccessionPage,
              selectedBulkAccessionPageSize:
                this.$route.query.selectedBulkAccessionPageSize,
              selectedBulkAccessionOrderBy:
                this.$route.query.selectedBulkAccessionOrderBy,
              selectedBulkAccessionOrderType:
                this.$route.query.selectedBulkAccessionOrderType,
              selectedBulkAccessionString:
                this.$route.query.selectedBulkAccessionString,
            },
          });
        } else {
          return this.$router.go(-1);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
.navbar-back-navigation-item {
  padding: 7px 15px;
  min-height: auto;
  color: #333;
  font-weight: 500;
  border-radius: 30px;
  transition: all 0.2s ease-in-out;
  font-size: 0.9em;
  text-transform: uppercase;
  border: 1.13636px solid #d9d9d9;

  span {
    &:nth-child(1) {
      display: flex;
      align-items: center;
      img {
        width: 15px;
      }
    }
  }
  .plus-icon {
    margin-right: 7px;
  }
  &:hover {
    background: #f2f2f2;
    color: #0a5da6;
  }
}
</style>
